import { Component, inject, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { Favorite } from 'src/app/state/user/favorites/models/favorites.response';
import { FavoritesFacade } from 'src/app/state/user/favorites/favorites.facade';
import { map } from 'rxjs';

@Component({
  selector: 'app-user-favorites',
  templateUrl: './user-favorites.component.html',
  styleUrls: ['./user-favorites.component.scss'],
})
export class UserFavoritesComponent {
  section = 'favorites';
  userService: UserService;
  hasLoadMore: boolean;
  favoritesLimit = 10;

  private readonly favoriteFacade = inject(FavoritesFacade);
  readonly paginatedFavorites$ = this.favoriteFacade.paginatedFavorites$;
  readonly emptyFavorites$ = this.paginatedFavorites$.pipe(map((paginatedFavorites) => !paginatedFavorites.items.length));

  constructor(
    userService: UserService,
    private router: Router,
  ) {
    this.userService = userService;
  }

  onFavoriteRemoved(favorite: Favorite) {
    this.favoriteFacade.deleteFavorite(favorite.recordId);
  }

  loadMore() {
    if (this.favoritesLimit < this.favoriteFacade.paginatedFavorites.items.length) {
      this.favoritesLimit += this.favoritesLimit;
    }
  }

  deleteAll() {
    this.favoriteFacade.deleteAllFavorites().subscribe();
  }

  goToLists() {
    this.router.navigate(['user/lists']);
  }
}
